import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable, PipeTransform } from '@angular/core';
import { StatusNotificationsDto } from '@dto/statusNotificationDto';
import { Observable } from 'rxjs';
import { EntityService } from './entity.service';
import { TableFilter } from '@models/tableFilter';

@Injectable({
  providedIn: 'root'
})

export class StatusNotificationsService extends EntityService {

  public entityRoute = "statusNotifications";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  static matches(statusNotification: StatusNotificationsDto, term: string, pipe?: PipeTransform) {
    return statusNotification.chargingStationId.includes(term.toLowerCase())
  }

  getAllStatusNotifications(filter: TableFilter = {}): Observable<StatusNotificationsDto[]> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = { headers: headers };

    return this.http.post<StatusNotificationsDto[]>(this.baseUrl + 'api/statusNotifications/all', filter, options);
  }

  getCountOfStatusNotifications(): Observable<number> {
    return this.http.get<number>(this.baseUrl + 'api/statusNotifications/count');
  }

  getStatusNotificationsForCurrentCustomer(entries: number = 100): Observable<StatusNotificationsDto[]> {
    return this.http.get<StatusNotificationsDto[]>(
      this.baseUrl + 'api/statusNotifications/forCurrentCustomer',
      { params: { entries: entries.toString() } }
    );
  }
}
